import { type ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/cn";

export type Crumb = { to?: string; label: string };

type Props = {
  title: string;
  description?: string;
  crumbs?: Crumb[];
  actions?: ReactNode;
  className?: string;
};

export function PageHeader({ title, description, crumbs, actions, className }: Props) {
  return (
    <div className={cn("mb-8", className)}>
      {crumbs && crumbs.length > 0 ? (
        <nav aria-label="Breadcrumb" className="mb-3 flex flex-wrap items-center gap-1 text-sm text-text-muted">
          {crumbs.map((c, i) => (
            <span key={i} className="inline-flex items-center gap-1">
              {c.to ? (
                <Link to={c.to} className="hover:text-text transition-colors">
                  {c.label}
                </Link>
              ) : (
                <span className="text-text">{c.label}</span>
              )}
              {i < crumbs.length - 1 ? <ChevronRight className="h-3.5 w-3.5 text-text-subtle" /> : null}
            </span>
          ))}
        </nav>
      ) : null}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
          {description ? <p className="mt-2 text-text-muted text-pretty">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
      </div>
    </div>
  );
}
